import { themeVariables } from "Components/theme";
import find from "lodash/find";
import forEach from "lodash/forEach";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import map from "lodash/map";
import noop from "lodash/noop";
import omit from "lodash/omit";
import reduce from "lodash/reduce";
import React, { useCallback, useEffect, useRef, useState } from "react";
import MessageComp, { getLinkHref, needMessageLink } from "./message";
const SIZES = {
    PANEL_WIDTH: 480,
    PANEL_BOTTOM: 20,
    PANEL_RIGHT: 20
};
const containerStyle = {
    position: "fixed",
    left: "auto",
    right: SIZES.PANEL_RIGHT,
    bottom: SIZES.PANEL_BOTTOM,
    width: SIZES.PANEL_WIDTH,
    zIndex: parseInt(themeVariables["zindex-app-popup-message"])
};
const isMessageEqual = (a, b) => {
    var _a, _b, _c, _d;
    return Boolean(a.type === b.type &&
        ((isString(a.message) && a.message === b.message) ||
            (get(a.message, "key") && get(a.message, "key") === get(b.message, "key"))) &&
        ((_a = a.messageLink) === null || _a === void 0 ? void 0 : _a.href) === ((_b = b.messageLink) === null || _b === void 0 ? void 0 : _b.href) &&
        ((_c = a.messageLink) === null || _c === void 0 ? void 0 : _c.title) === ((_d = b.messageLink) === null || _d === void 0 ? void 0 : _d.title));
};
export default function PopupMessage(props) {
    const [messages, setMessages] = useState({});
    const timersRef = useRef({});
    useEffect(() => () => {
        forEach(timersRef.current, timer => {
            timer && clearTimeout(timer);
        });
    }, []);
    const removeMessage = useCallback((id) => {
        timersRef.current[id] && clearTimeout(timersRef.current[id]);
        setMessages(prevMessages => omit(prevMessages, id));
    }, []);
    const getDelay = useCallback((id, messagesMap) => { var _a; return !needMessageLink((_a = messagesMap[id]) === null || _a === void 0 ? void 0 : _a.messageLink) ? props.regularTimeout : props.extendedTimeout; }, [props.regularTimeout, props.extendedTimeout]);
    const tryAddMessages = useCallback((newMessages) => {
        if (!newMessages.length)
            return;
        const newMessagesIds = map(newMessages, "id");
        props.onProcessed(newMessagesIds);
        const ids = [];
        const newOrUpdatedMessages = reduce(newMessages, (res, curr) => {
            const item = {
                ...omit(curr, "messageLink"),
                messageLink: curr.messageLink
                    ? {
                        ...omit(curr.messageLink, ["href", "routingKey"]),
                        href: getLinkHref(curr.messageLink.href, curr.messageLink.routingKey)
                    }
                    : undefined
            };
            const prev = find(messages, e => isMessageEqual(e, item));
            if (prev) {
                ids.push(prev.id);
                return { ...res, [prev.id]: { ...prev, count: (prev.count || 1) + 1 } };
            }
            ids.push(curr.id);
            return {
                ...res,
                [curr.id]: item
            };
        }, {});
        setMessages(prevMessages => ({
            ...prevMessages,
            ...newOrUpdatedMessages
        }));
        forEach(ids, id => {
            var _a;
            timersRef.current[id] && clearTimeout(timersRef.current[id]);
            if (!((_a = newOrUpdatedMessages[id]) === null || _a === void 0 ? void 0 : _a.autoHide))
                return;
            timersRef.current[id] = setTimeout(() => {
                removeMessage(id);
            }, getDelay(id, newOrUpdatedMessages));
        });
    }, [getDelay, messages, props.onProcessed]);
    useEffect(() => {
        tryAddMessages(props.messages);
    }, [props.messages]);
    const handleMouseEnter = useCallback((id) => {
        timersRef.current[id] && clearTimeout(timersRef.current[id]);
    }, []);
    const handleMouseLeave = useCallback((id) => {
        if (!messages[id] || !messages[id].autoHide)
            return;
        timersRef.current[id] = setTimeout(() => {
            removeMessage(id);
        }, getDelay(id, messages));
    }, [getDelay, messages]);
    if (isEmpty(messages))
        return null;
    return (React.createElement("div", { className: "unselectable", style: containerStyle }, map(messages, item => (React.createElement(MessageComp, { key: item.id, data: item, onClose: removeMessage, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave })))));
}
PopupMessage.defaultProps = {
    messages: [],
    regularTimeout: 4000,
    extendedTimeout: 10000,
    onProcessed: noop
};
